import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'
import { ControlPosition, IControl } from 'mapbox-gl'
import { Icon } from '@iconify/vue2'
import { MapBoxDrawEnum } from './enums/MapBoxDrawMode.enum'
import { useMapBox } from './composables/useMapBox'
import { MapProvider } from './providers/Map.provider'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxDrawLineControl',
  props: {
    position: null
  },
  setup(__props: any) {

const props = __props as {
	position?: ControlPosition
};



let control: IControl | undefined

const drawPolygonButton = ref<HTMLElement>()

const { map, draw } = useMapBox()

onMounted(() => {
	let container: HTMLDivElement

	control = {
		onAdd() {
			container = document.createElement('div')
			container.className = 'mapboxgl-ctrl'

			drawPolygonButton.value?.addEventListener('click', () => {
				MapProvider.clearLineString(draw?.value)
				draw?.value?.changeMode(MapBoxDrawEnum.DRAW_LINE_STRING)
			})

			container.appendChild(drawPolygonButton.value!)

			return container
		},
		onRemove() {
			container?.remove()
		},
	}

	setTimeout(() => map?.value?.addControl(control!, props.position || 'top-right'), 500)
})

onUnmounted(() => {
	if (control) map?.value?.removeControl(control)
})

return { __sfc: true,props, control, drawPolygonButton, map, draw, Icon }
}

})